const CONSTANTS = {
    API_BASE_PATH: process.env.VUE_APP_API_BASE_PATH,
    ASSISTANT_API_BASE_PATH: process.env.VUE_APP_ASSISTANT_API_BASE_PATH,
    JSSDK_API_BASE_PATH: process.env.VUE_APP_JSSDK_API_BASE_PATH,
    DEVELOPER_DOMAIN: process.env.VUE_APP_DEVELOPER_DOMAIN,
    ECOMMERCE_DOMAIN: process.env.VUE_APP_ECOMMERCE_DOMAIN,
    SCRAPE_STATES:  {
      unscraped: 0,
      scraped: 1,
      approved: 2,
      validating: 3,
      scraping: 4,
      failed: 5
    },
    DEFAULT_ENTITY_LIMITS: {
      pikles: 10,
      piklesPerCategory: 2,
      options: 20,
      stores: 5,
      members: 10,
      features: 20
    },
    DECISION_TYPES: [
      {id: 'pick-one', name: 'Pick One', icon: 'mdi-podium-gold', description: 'Choose a single best option'},
      {id: 'rank-options', name: 'Rank Options', icon: 'mdi-sort-ascending', description: 'Create a ranked list of options'},
      // {id: 'pick-multiple', disabled: true, name: 'Decision Bundle', icon: 'mdi-podium', description: 'Manage a bundle of related options and decisions'}
    ],
    DECISION_MODELS: [
      {
        id: 'openAI',
        name: 'OpenAI GPT',
        description: 'Advanced AI model for complex decision-making tasks from OpenAI',
        icon: 'mdi-robot-happy-outline'
      },
      {
        id: 'claude',
        name: 'Anthropic Claude',
        description: 'AI model focused on helpfulness and safety from Anthropic',
        icon: 'mdi-robot-happy-outline'
      }
    ],
    AVAILABLE_MODELS: {
      "gpt-5-mini": { id: 'gpt-5-mini', name: 'GPT-5' },
      "gpt-4o": { id: 'gpt-4o', name: 'GPT-4o' },
      "gemini": { id: 'gemini/gemini-3.8-flash', name: 'Gemini 3.8' },
      "claude": { id: 'claude-sonnet-5', name: 'Claude 5' }
    },
    ASSISTANT_MESSAGE_COLLECTIONS: {
      decisions: {
        "pick-one": "assistants-decision-board-choose-one",
        "rank-options": "assistants-decision-board-choose-one" // Choose one and ranking boards use the same collection. They are just variantes of rank with a limit of one for the choose one
      },
      gettingStarted: "assistants-getting-started"
    },
    PIKLE_ENV: process.env.VUE_APP_PIKLE_ENV
}

export default CONSTANTS
